import {ServiceActions, ServiceMutations} from "./types";
import axios from "axios";

export default {
    [ServiceActions.LOAD]({commit}, payload) {
        return new Promise((resolve, reject) => {
            commit(ServiceMutations.REQUEST);

            let {sortBy, sortDesc, page, itemsPerPage} = payload.options;

            axios.post('/service', {
                sortBy,
                sortDesc,
                page,
                itemsPerPage,
                filter: payload.filter,
            })
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(ServiceMutations.SUCCESS, data);
                    resolve(data);
                })
                .catch(err => {
                    commit(ServiceMutations.ERROR, err.response?.data || err);
                    reject(err);
                });
        });
    },
    [ServiceActions.CONFIRM]({commit}, {id}) {
        return new Promise((resolve, reject) => {
            commit(ServiceMutations.SAVING, true);

            axios.post(`/service/${id}/accept`)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(ServiceMutations.CONFIRM, id);
                    resolve(data);
                })
                .catch(err => {
                    commit(ServiceMutations.ERROR, err.response.data || err);
                    reject(err);
                })
                .finally(() => {
                    commit(ServiceMutations.SAVING, false);
                });
        });
    },
    [ServiceActions.DECLINE]({commit}, {id}) {
        return new Promise((resolve, reject) => {
            commit(ServiceMutations.SAVING, true);

            axios.post(`/service/${id}/decline`)
                .then(resp => {
                    return resp.data;
                })
                .then(data => {
                    commit(ServiceMutations.DECLINE, id);
                    resolve(data);
                })
                .catch(err => {
                    commit(ServiceMutations.ERROR, err.response.data || err);
                    reject(err);
                })
                .finally(() => {
                    commit(ServiceMutations.SAVING, false);
                });
        });
    },
}
